module.exports = __webpack_public_path__ + "static/media/ny-che-big@2x.3303331c.png";